type AnalyticsPayload = Record<string, unknown>;

const DEFAULT_DATA_LAYER_NAME = 'dataLayer';
const LINK_EVENTS = new Set(['cta_click', 'select_aggregator']);

function getDataLayerName(): string {
	return document.documentElement.dataset.analyticsDataLayer?.trim() || DEFAULT_DATA_LAYER_NAME;
}

function parsePayload(element: HTMLElement): AnalyticsPayload {
	const value = element.dataset.analyticsPayload;

	if (!value) {
		return {};
	}

	try {
		const payload: unknown = JSON.parse(value);
		return payload !== null && typeof payload === 'object' && !Array.isArray(payload)
			? (payload as AnalyticsPayload)
			: {};
	} catch {
		return {};
	}
}

export function pushAnalyticsEvent(eventName: string, payload: AnalyticsPayload = {}): boolean {
	const event = eventName.trim();

	if (!event) {
		return false;
	}

	const dataLayerName = getDataLayerName();
	const globalWindow = window as unknown as Record<string, unknown>;
	let dataLayer = globalWindow[dataLayerName];

	if (!Array.isArray(dataLayer)) {
		dataLayer = [];
		globalWindow[dataLayerName] = dataLayer;
	}

	dataLayer.push({
		event,
		...payload
	});

	return true;
}

function handleTrackedClick(clickEvent: MouseEvent): void {
	if (!(clickEvent.target instanceof Element)) {
		return;
	}

	const trackedElement = clickEvent.target.closest<HTMLElement>('[data-analytics-event]');
	const eventName = trackedElement?.dataset.analyticsEvent?.trim();

	if (!trackedElement || !eventName) {
		return;
	}

	const payload = parsePayload(trackedElement);
	payload.source_page = window.location.pathname;

	if (LINK_EVENTS.has(eventName) && trackedElement instanceof HTMLAnchorElement) {
		payload.link_url = trackedElement.href;
		payload.link_text =
			trackedElement.dataset.analyticsLinkText?.trim() ||
			trackedElement.textContent?.trim().replace(/\s+/g, ' ') ||
			'';
	}

	pushAnalyticsEvent(eventName, payload);
}

document.addEventListener('click', handleTrackedClick, { capture: true });
